// Vite/browser polyfills for node-isms used by amazon-cognito-identity-js
// Keep this file imported first in main.tsx.

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const g: any = globalThis as any;

if (!g.global) g.global = g;

// Buffer polyfill (used internally by cognito deps)
import { Buffer } from 'buffer';
if (!g.Buffer) g.Buffer = Buffer;

// process polyfill (some deps probe process.env)
import process from 'process';
if (!g.process) g.process = process;
